import { useState, useEffect } from 'react';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import './style.css';
import AlertMessage from '../../components/Alert';
import { CardContent } from '../../components/CardContent';
import { Main } from '../../components/Main';
import { Title } from '../../components/Title';
import { Button, Col, Dropdown, Form, Modal, Pagination, Row } from 'react-bootstrap';
import { Label } from '../../components/Label';
import api from '../../services/api';
import { Autocomplete, LinearProgress, TextField, Typography, Box } from '@mui/material';
import { Options, Select } from '../../components/Select';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import Search from '../../components/Search';
import { FillPlus } from '../../components/Icons';
import { Eye, ExclamationTriangleFill, CheckCircleFill, FileArrowDown, Search as SearchIcon } from 'react-bootstrap-icons';
import './style.css';
import DocumentoReaproveitamento from '../DocumentoReaproveitamento';
import jsPDF from 'jspdf';

const ReaproveitamentoAso = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [reaproveitamentos, setReaproveitamentos] = useState([])
    const [empresa, setEmpresa]: any = useState(null);
    const [idEmpresa, setIdEmpresa]: any = useState(null);
    const [showModalExame, setShowModalExame] = useState(false);
    const [showDoc, setShowDoc] = useState(false)
    const [tabelaAtiva, setTabelaAtiva] = useState('tabela1');
    const [asosEnviados, setAsosEnviados]: any = useState([])
    const [funcoesReaproveitamento, setFuncoesReaproveitamento] = useState<any>([]);
    const [examesReaproveitados, setExamesReaproveitados] = useState<any>([]);
    const [tempExames, setTempExames] = useState<any>([]);
    const [indexAso, setIndexAso]: any = useState(null);
    const [selectedIndexAso, setSelectedIndexAso] = useState()
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('Todos');
    const [searchTermDocumentosEnviados, setSearchTermDocumentosEnviados] = useState('')
    const [filterStatusDocumentosEnviados, setFilterStatusDocumentosEnviados] = useState('Todos')
    const [selectedTrabalhador, setSelectedTrabalhador] = useState<any>(null);
    const [selectedReaproveitamento, setSelectedReaproveitamento] = useState<any>(null);
    const [selectedEmpresa, setSelectedEmpresa] = useState<any>(null);

    // States para paginação
    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredReaps, setCurrentFilteredReaps] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [reapsPerPage, setReapsPerPage] = useState(20);
    const [reapsPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const indexOfLastReap = currentPage * reapsPerPage;
    const indexOfFirstReap = indexOfLastReap - reapsPerPage;

    const handleReapsPerPageChange = (value: any) => {
        setReapsPerPage(Number(value));
        setCurrentPage(1); 
    };

    const handleShowDoc = (id: any, idTrabalhador: any, idEmpresa: any) => {
        setSelectedTrabalhador(idTrabalhador);
        setSelectedEmpresa(idEmpresa);
        setIndexAso(id);
        setShowDoc(true);
    };

    const handleCloseDoc = () => {
        setShowDoc(false);
    };

    const handleShowExame = () => setShowModalExame(true);
    const handleCloseExame = () => setShowModalExame(false);

    const handleMostrarTabela1 = () => {
        setTabelaAtiva('tabela1');
    };

    const handleMostrarTabela2 = () => {
        setTabelaAtiva('tabela2');
    };

    useEffect(() => {
        const fetchData = async () => {
            await handleListCompany();
            await fetchReaproveitamentos();
        };

        fetchData();
    }, [idEmpresa]);

    const fetchReaproveitamentos = async () => {
        try {
            const response = await api.post(`buscar-reaproveitamento-aso/${idEmpresa}`)
            setReaproveitamentos(response.data.reaproveitamento)
            setAsosEnviados(response.data.asosEnviados)
            setFuncoesReaproveitamento(response.data.funcoes)
        } catch (error) {
            console.log(error)
        }
    }


    const handleListCompany = async () => {
        try {
            const response = await api.post('listar-empresa-aso');
            setEmpresa(response.data.empresa);
            setIdEmpresa(response.data.empresa.id);
        } catch (error) {
            console.log(error)
        }
    }

    const handleViewDetails = async (id: number) => {
        try {
            const response = await api.get(`buscar-exames-reaproveitamento/${id}`);
            setExamesReaproveitados(response.data.reaproveitamentos)
            setTempExames(response.data.examesQuarentena)
            setShowModalExame(true);
        } catch (error) {
            console.error('Erro ao buscar os dados:', error);
        }
    };

    const combinedData = [
        ...examesReaproveitados
            .filter((item: any) => item.index_aso === selectedIndexAso)
            .map((reaproveitamento: any) => ({
                type: 'ASO',
                nome: reaproveitamento.ateBaseExames.nome,
                data: reaproveitamento.data_realizacao
            })),
        ...tempExames
            .filter((exam: any) => exam.index_aso === selectedIndexAso)
            .map((tempExame: any) => ({
                type: 'Exame',
                nome: tempExame.nome,
                data: tempExame.data_realizacao
            }))
    ];


    const formatarDataModal = (dateString: any) => {
        const isValidDateFormat = (dateStr: any) => {
            const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
            return regex.test(dateStr);
        };

        const formatToDateTime = (date: any) => {
            const day = date.getDate().toString().padStart(2, "0");
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const year = date.getFullYear();
            const hours = (date.getHours()).toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");

            return `${day}/${month}/${year} às ${hours}h${minutes}`;
        };

        if (isValidDateFormat(dateString)) {
            const [day, month, year] = dateString.split("/");
            const date = new Date(`${year}-${month}-${day}`);
            return formatToDateTime(date);
        }
        const date = new Date(dateString);
        return formatToDateTime(date);
    }

    const formatDate = (isoDate: any) => {
        const date = new Date(isoDate);

        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();

        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} às ${hours}:${minutes}:${seconds}`;
    }

    const filteredReaproveitamentos = reaproveitamentos.filter((reap: any) =>
        (filterStatus === 'Todos' ||
            (filterStatus === 'Aguardando liberação' && (reap.liberado == 0 && reap.assinado_trabalhador == 0)) ||
            (filterStatus === 'Documento liberado' && (reap.liberado == 1 && reap.assinado_trabalhador == 1)) ||
            (filterStatus === 'Aguardando assinatura' && (reap.liberado == 1 && reap.assinado_trabalhador == 0))
        ) &&
        (reap.pgrTrabalhador.cpf.includes(searchTerm) ||
            reap.pgrTrabalhador.nome.toLowerCase().includes(searchTerm.toLowerCase()))
    );


    const filteredDocumentos = asosEnviados.filter((reap: any) =>
        (filterStatusDocumentosEnviados === 'Todos' ||
            (filterStatusDocumentosEnviados === 'Aguardando liberação' && reap.liberado == 0) ||
            (filterStatusDocumentosEnviados === 'Liberado' && reap.liberado == 1)
        ) &&
        (reap.pgrTrabalhador.cpf.includes(searchTermDocumentosEnviados) ||
            reap.pgrTrabalhador.nome.toLowerCase().includes(searchTermDocumentosEnviados.toLowerCase()))
    );


    return (
        <>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Title text='ASOS Gerados'></Title>

                <CardContent>
                <Title text='ASOS Gerados pela empresa'></Title>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(reaproveitamentos.length / reapsPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='reapsPerPageSelect' onSelect={handleReapsPerPageChange}>
                                {reapsPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === reapsPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Row className="d-flex justify-content-center mb-4">
                            <Col xs="auto" className="text-center">
                                <Title text="Selecione o que deseja visualizar:" />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center mb-4">
                                <Button
                                    variant={tabelaAtiva === 'tabela1' ? 'primary' : 'outline-primary'}
                                    onClick={handleMostrarTabela1}
                                    className="me-2"
                                >
                                    ASOS Gerados
                                </Button>
                                <Button
                                    variant={tabelaAtiva === 'tabela2' ? 'primary' : 'outline-primary'}
                                    onClick={handleMostrarTabela2}
                                >
                                    Documentos cadastrados manualmente
                                </Button>
                            </Col>
                        </Row>
                        <Col md={12}>
                            {tabelaAtiva === 'tabela1' && (
                                <>
                                    <Row style={{ marginBottom: '20px', justifyContent: 'center' }}>
                                        <Col xs="auto">
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <SearchIcon
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '20px',
                                                        transform: 'translateY(-50%)',
                                                        color: '#6c757d',
                                                        fontSize: '18px',
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Buscar por CPF ou Nome"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    style={{
                                                        padding: '10px 10px 10px 40px',
                                                        width: '300px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #0d6efd'
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col xs="auto">
                                            <label
                                                htmlFor=""
                                                style={{
                                                    fontSize: '16px',
                                                    marginRight: '10px',
                                                }}
                                            >
                                                Status:
                                            </label>
                                            <select
                                                value={filterStatus}
                                                onChange={(e) => setFilterStatus(e.target.value)}
                                                style={{
                                                    padding: '10px',
                                                    width: '250px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #0d6efd',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                <option value="Todos">Todos</option>
                                                <option value="Aguardando liberação">Aguardando liberação</option>
                                                <option value="Documento liberado">Documento liberado</option>
                                                <option value="Aguardando assinatura">Aguardando assinatura</option>
                                            </select>
                                        </Col>

                                    </Row>

                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table>
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Cód</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Funcionário</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Função</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Frente de Trabalho</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Status</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Data Cadastro</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredReaproveitamentos && filteredReaproveitamentos.length > 0 ? (
                                                    filteredReaproveitamentos.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                {item.id}
                                                            </td>
                                                            <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                {item.pgrTrabalhador.nome}
                                                                <div style={{ fontSize: '13px', color: '#777', marginTop: '5px', fontWeight: 'bold' }}>
                                                                    CPF: {item.pgrTrabalhador.cpf}
                                                                </div>
                                                            </td>
                                                            <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                {item.funcao.nome}
                                                            </td>
                                                            <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                {item.frente_de_trabalho}
                                                            </td>
                                                            <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', color: item.liberado ? (item.assinado_trabalhador ? 'green' : '#FFA500') : 'red' }}>
                                                                {item.liberado ? (
                                                                    item.assinado_trabalhador ? (
                                                                        <>
                                                                            <CheckCircleFill style={{ marginBottom: '5px' }} /> Documento liberado
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ExclamationTriangleFill style={{ marginBottom: '5px' }} /> Aguardando assinatura do Trabalhador
                                                                        </>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        <ExclamationTriangleFill style={{ marginBottom: '5px' }} /> Aguardando liberação
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                {formatDate(item.created_at)}
                                                            </td>
                                                            <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                {item.assinado_trabalhador === 1 && (
                                                                    <Button variant='primary' onClick={() => handleShowDoc(item.id, item.id_trabalhador, item.id_empresa)}>
                                                                        <FileArrowDown />
                                                                    </Button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td style={{ padding: '15px' }}>
                                                            Nenhum reaproveitamento disponível
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </Row>
                                </>
                            )}

                            {tabelaAtiva === 'tabela2' && (
                                <>
                                    <Row style={{ marginBottom: '20px', justifyContent: 'center' }}>
                                        <Col xs="auto">
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <SearchIcon
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '20px',
                                                        transform: 'translateY(-50%)',
                                                        color: '#6c757d',
                                                        fontSize: '18px',
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Buscar por CPF ou Nome"
                                                    value={searchTermDocumentosEnviados}
                                                    onChange={(e) => setSearchTermDocumentosEnviados(e.target.value)}
                                                    style={{
                                                        padding: '10px 10px 10px 40px',
                                                        width: '300px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #0d6efd'
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col xs="auto">
                                            <label
                                                htmlFor=""
                                                style={{
                                                    fontSize: '16px',
                                                    marginRight: '10px',
                                                }}
                                            >
                                                Status:
                                            </label>
                                            <select
                                                value={filterStatusDocumentosEnviados}
                                                onChange={(e) => setFilterStatusDocumentosEnviados(e.target.value)}
                                                style={{
                                                    padding: '10px',
                                                    width: '200px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #0d6efd',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                <option value="Todos">Todos</option>
                                                <option value="Aguardando liberação">Aguardando liberação</option>
                                                <option value="Liberado">Liberado</option>
                                            </select>
                                        </Col>

                                    </Row>


                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        {/* Aqui você pode adicionar a segunda tabela */}
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Cód</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Funcionário</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Funções</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Cadastro</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Status</th>
                                                    <th style={{ fontSize: '14px', padding: '15px', fontWeight: 'normal' }}>Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredDocumentos && filteredDocumentos.length > 0 ? (
                                                    filteredDocumentos.map((reap: any, index: number) => {
                                                        return (
                                                            <tr key={reap.id}>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.id}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {reap.pgrTrabalhador.nome}
                                                                    <div style={{ fontSize: '13px', color: '#777', marginTop: '5px', fontWeight: 'bold' }}>
                                                                        CPF: {reap.pgrTrabalhador.cpf}
                                                                    </div>
                                                                </td>
                                                                <td style={{ fontSize: '11px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {
                                                                        funcoesReaproveitamento
                                                                            .filter((funcao: any) => funcao.index_aso === reap.id)
                                                                            .map((funcao: any) => funcao.nomes)
                                                                            .join(', ') || 'Nenhuma função encontrada'
                                                                    }
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold' }}>
                                                                    {formatDate(reap.created_at)}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', color: reap.liberado ? 'green' : '#FFA500' }}>
                                                                    {reap.liberado ? (
                                                                        <>
                                                                            <CheckCircleFill style={{ marginBottom: '5px' }} /> Liberado
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ExclamationTriangleFill style={{ marginBottom: '5px' }} /> Aguardando liberação
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td style={{ fontSize: '13px', padding: '15px', fontWeight: 'bold', display: 'inline-flex', gap: '10px' }}>
                                                                    <Button variant="primary" onClick={() => {
                                                                        setSelectedIndexAso(reap.id);
                                                                        handleViewDetails(reap.id)
                                                                    }}>
                                                                        <>
                                                                            <Eye size={20} />
                                                                        </>
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td style={{ padding: '15px' }}>
                                                            Nenhum reaproveitamento disponível
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </Row>
                                </>
                            )}
                        </Col>
                    </Row>
                </CardContent>

                <Modal size="xl" show={showModalExame} onHide={handleCloseExame}>
                    <Modal.Header closeButton>
                        <b>Exames Incluídos</b>
                    </Modal.Header>
                    <Modal.Body>
                        {combinedData.length > 0 ? (
                            <Table>
                                <THeader className="table-row-funcao">
                                    <ThCell>Exame</ThCell>
                                    <ThCell>Data de Realização</ThCell>
                                </THeader>
                                <TBody>
                                    <TGroup>
                                        {combinedData.map((item: any, index: number) => (
                                            <TRow className="table-row-funcao" key={index}>
                                                <TCell>{item.nome}</TCell>
                                                <TCell>{formatarDataModal(item.data)}</TCell> {/* Formata a data */}
                                            </TRow>
                                        ))}
                                    </TGroup>
                                </TBody>
                            </Table>
                        ) : (
                            <p>Não há dados disponíveis</p>
                        )}
                    </Modal.Body>
                </Modal>

                {showDoc && (
                    <DocumentoReaproveitamento
                        idEmpresa={selectedEmpresa}
                        idTrabalhador={selectedTrabalhador}
                        indexAso={indexAso}
                        onClose={handleCloseDoc}
                    />
                )}
            </Main>

            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />

        </>
    );
}

export default ReaproveitamentoAso;
